/**
 * @fileoverview This is the javascript file for local optimization flows.
 *
 * @author Bo Chen
 */
goog.provide('yext.storm.Logecl');

goog.require('yext');
goog.require('yext.Field');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.location.StringList');
goog.require('yext.location.categories');
goog.require('yext.location.facebook.ViewController');
goog.require('yext.location.Websites');
goog.require('yext.location.hours.DayHours');
goog.require('yext.location.photo');
goog.require('yext.location.SpecialOffer');
goog.require('yext.location.List');
goog.require('yext.notify');
goog.require('yext.photoupload.Photo');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.storm.enhancedlists.LOGItems');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.textfield');
goog.require('yext.textfield.events');
goog.require('yext.time');
goog.require('yext.videochooser');
goog.require('yext.youtube');
goog.require('yext.utils.youtube');
goog.require('yext.location.MapMarkerView');
goog.require('yext.location.MultipleSelect');
goog.require('yext.storm.fields');
goog.require('yext.storm.logflownav');

(function() {
  const logRoutes = {};
  goog.exportSymbol('logRoutes', logRoutes);

  /**
   * Utilities Used on Mutiple Log Pages
   * @constructor
   */
  const LogUtilities = function(options) {
    this.options = options;
  };

  /**
   * Updates the video preview for add video step
   * @param  {!Object} videoInfo video info for a youtube video
   */
  LogUtilities.prototype.updateVideoPreview = function(videoInfo) {
    const template = $('.video-display-template').html();
    const html = yext.utils.youtube.fixupVideoTemplate(template, videoInfo);
    // update thumbnail
    $('.js-add-youtube-video').addClass('is-thumbnail').css('background-image', 'url(\'' + videoInfo.thumbnail + '\')');
    // update video
    $('.youtube-preview').html(html);
    $('.js-delete-youtube-video').removeAttr('style');
  };

  /**
   * Common bindings that can be used in all LOG pages
   * @constructor
   */
  const LogCommon = function() {
    this.bindGeneralHandlers();
    this.bindFieldSubmit();
    this.bindBuildlistingNext();
    this.bindNavButtons();
    this.bindCharCount();
    this.bindLocationWidget();
    this.bindPlaceholder();
    // TODO (ecrowe): Create a global static variable EntityGoalExists or something
    // if the page calls yext.customgoals.entity.EntityGoal in script#js-entitygoal-init,
    // do not initialize the common bindings below; doing so would cause double bindings
    if ($('#js-entitygoal-init').length) {
      return;
    }
    this.initOptionListFields();
    this.bindAddPhotosAndVideos();
    this.bindContentList();
    this.bindSocialPost();
    yext.dam.assetselector.init({
      'locationSearchParam': encodeURIComponent('entityIds=' + $('.js-locationIds-list').val()),
    });
    yext.location.photo.create($('.js-single-photo'), {
      alertErrors: true,
      size: {
        width: 100,
        height: 100,
      },
    });
    this.bindGalleryPhotos();
    this.textFields();
    this.bindSpecialOffer();
    this.bindWebsites();
    this.bindHours();
    this.bindCategories();
    this.bindListFields();
    this.bindNewMapMarker();

    // Don't initialize controller on Facebook page found and claimed since those are view only
    if ($('.fb-claimed').length == 0 && $('.fb-found').length == 0) {
      new yext.location.facebook.ViewController('location.facebook_cover_photo');
      new yext.location.facebook.ViewController('location.facebook_profile_photo');
    }
  };
  goog.exportSymbol('LogCommon', LogCommon);

  /**
   * Bind new map marker field
   */
  LogCommon.prototype.bindNewMapMarker = function() {
    const $ctx = $('.js-map-marker');

    if (!$ctx.length) {
      return;
    }

    this.marker = new yext.location.MapMarkerView($ctx, true);
    const $row = $ctx.closest('.map-edit-container');
    this.marker.bindEditTarget($row);
  };

  /**
   * Bind all list style fields
   */
  LogCommon.prototype.bindListFields = function() {
    $('.js-list-field-context').each(function() {
      new yext.location.List($(this));
    });
  };

  /**
   * Bind general event handlers for Log flow
   */
  LogCommon.prototype.bindGeneralHandlers = function() {
    /**
     * This changes the <Various ..> text to a placeholder
     */
    $('.various').each(function() {
      const $this = $(this);

      $this.attr('placeholder', $this.val());
      yext.storm.logflownav.clearVarious(this);
    });
    /**
     * Clears the indeterminate flag when a user starts typing
     */
    const $variousFields = $('.on-change-save-various');
    $variousFields.data('field-changed', false);

    $variousFields.keydown(function() {
      yext.storm.fields.clearIndeterminate(this);
      $(this).data('field-changed', true);
    });
  };

  /**
   * Subscribe to an event from social.js to tap into ability to enable
   * next button after a post is submitted
   */
  LogCommon.prototype.bindSocialPost = function() {
    $('#fb-post-form').on('social.postSuccess', function() {
      $('.log-post-success').show();
      $('.js-next-button').removeClass('btn-disabled');
    });
  };

  /**
   * Binds content list sortable
   */
  LogCommon.prototype.bindContentList = function() {
    const $contentList = $('#content-list');
    const $list = $contentList.find('.enhancedLists-list');
    const $contentListReorderd = $contentList.find('.enhancedLists-reordered');

    $contentList.find('.indeterminate').prop('indeterminate', true);

    $contentList.data('list-changed', false);

    $contentList.on('log.formChanged', function() {
      $contentList.data('list-changed', true);
    });

    $list.sortable({
      axis: 'y',
      change: function() {
        $contentListReorderd.val('true');
        yext.storm.logflownav.enableNextInLogFlow();
        $contentList.data('list-changed', true);
      },
      containment: $list,
      tolerance: 'pointer',
    });
  };

  /**
   * Make the next button trigger submit
   */
  LogCommon.prototype.bindBuildlistingNext = function() {
    $(document).on('click.log', '.js-next-button', function() {
      if ($(this).hasClass('btn-disabled')) {
        LogCommon.prototype.alertIncompleteTask();
        return;
      }

      const $form = $('.js-field-submit,.js-log-field');
      if ($form.length) {
        $form.submit();
      } else {
        // No form to submit, just proceed to next page (happens in Logo edit)
        goToNextPage();
      }
    });
  };

  /**
   * Sets Placeholders Using Plugin (for IE browsers)
   */
  LogCommon.prototype.bindPlaceholder = function() {
    if ($('html.lt-ie10').length > 0) {
      $('input, textarea').placeholder();
    }
  };

  /**
   * Bind submit processing
   */
  LogCommon.prototype.bindFieldSubmit = function() {
    const self = this;
    $('.js-field-submit').submit(function() {
      let data = null;
      const route = logRoutes.updateField;
      const $self = $(this);
      const formId = $self.attr('id');

      if (formId == 'emails') {
        data = $self.serializeArray();
      } else if (formId == 'hours') {
        return false; // bindHours takes care of it
      } else if (formId == 'content-list') {
        /**
         * In the scenario where the next button is enabled without any changes
         * having been made to the content list (ex. reset) the goal should be
         * marked as completed when the user hits next
         */
        if (!$self.data('list-changed')) {
          markCompleted();
          return false;
        }
        data = window.serializeEnhancedLists($self, $self.data('field-name'));
      } else if (formId === 'newMapMarker') {
        data = {
          'field': 'virtual.map_marker',
          'virtual.map_marker': yext.JSON.stringify({'markers': self.marker.fetchData()}),
        };
      }
      /**
       * When in the indeterminate state for the basic fields, and the next button
       * is enabled (ex. reset) without any changes being made the user should
       * be able to hit next and have the goal marked as completed
       */
      const $variousContentField = $self.find('.on-change-save-various');
      if ($variousContentField.length && !$variousContentField.data('field-changed')) {
        markCompleted();
        return false;
      }

      return onSubmitBase(this, data, route, validateAndGoToNextPage);
    });
  };

  LogCommon.prototype.bindNavButtons = function() {
    $('.log-skip').click(function() {
      skipPage();
    });

    $('.js-opt-out').click(function() {
      optOut();
    });

    $('.js-does-not-apply').click(function() {
      doesNotApply();
    });
  };

  LogCommon.prototype.bindCharCount = function() {
    $('.item-char-count, .special-offer-char-count').not('.initialized').each(function() {
      const $charsRemaining = $(this);
      const $field = $charsRemaining.siblings('input[type="text"], textarea');
      $(this).addClass('initialized');
      $field.focusout(function() {
        $charsRemaining.empty();
      });
      $field.bind('keypress change input paste focusin', function() {
        const remaining = $field.attr('maxlength') - $field.val().length;
        // TRANSLATORS: Displays count of remaining characters when typing
        // EXAMPLE: 50 characters remaining
        const text = yext.msgn('1 character remaining', '{0} characters remaining', remaining);
        $charsRemaining.text(text);
      });
    });
  };

  LogCommon.prototype.bindLocationWidget = function() {
    $('.js-location-widget-toggle').click(function() {
      $('.js-location-widget').toggle();
    });
  };

  LogCommon.prototype.alertIncompleteTask = function() {
    $('.task-incomplete-bubble').show();
  };

  LogCommon.prototype.initOptionListFields = function() {
    $('.js-multiple-select-field').each(function() {
      new yext.location.MultipleSelect($(this));
    });
  };

  /**
   * Bind event handlers specific to the add photos and videos goal
   */
  LogCommon.prototype.bindAddPhotosAndVideos = function() {
    $('.js-reset-youtube-video').click(function() {
      $('.js-youtube-indeterminate').hide();
      $('.js-add-youtube-video-wrap').fadeIn();
    });
  };

  /**
   * Upload photos to gallery
   */
  LogCommon.prototype.bindGalleryPhotos = function() {
    const $form = $('.js-gallery-upload-form');
    const $photoWrapper = $($('.js-photo-wrapper-template').html());
    let $currentImage;

    if (!$form.length) {
      return;
    }

    const field = new yext.Field($form);
    let timeout;

    $('.js-log-gallery').click(function() {
      $currentImage = $(this);

      $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
        timeout = yext.dialog.showDelayedProgressDialog(yext.msg('Updating gallery...'));
        // Remove unnecessary asset object properties
        delete asset.UID;
        delete asset.labels;

        const image = {
          'description': '',
          'checked': true,
          'descriptionIndeterminate': false,
          'detailsIndeterminate': false,
          'clickthroughUrlIndeterminate': false,
          'destinations': [
          ],
        };

        if (asset.croppedImage) {
          image.croppedImage = asset.croppedImage;
          if (asset.file) {
            image.croppedImageName = asset.file.name;
          } else {
            image.croppedImageName = asset.photoUrl;
          }
        }

        if (asset.file) {
          field.addFile(asset.file, asset.fileInput);
          asset.fileIndex = 0;
          delete asset.file;
          delete asset.fileInput;
          delete asset.photoUrl;
          delete asset.croppedImage;
        }

        image.asset = asset;

        field.additionalData = [{
          name: 'photos',
          value: yext.JSON.stringify([image]),
        }];
        yext.dialog.hideDelayedProgressDialog(timeout);
        $form.submit();
      });

      const fieldId = 'location.gallery';
      yext.dam.assetselector.show({
        'type': yext.dam.assetselector.types.PHOTO,
        'includeUsedAssets': false,
        'hideEnterImageUrl': false,
        'usageType': goog.module.get('yext.dam.assetselector.usage').forProfileFields(fieldId),
      },
      fieldId,
      false);
    });

    $form.on('save.field', function(e, response) {
      if (response.error || !response.success) {
        yext.dialog.hideDelayedProgressDialog();
        yext.dialog.showErrorDialog(response.error);
      } else {
        $currentImage.off('click');
        const img = new Image();
        img.display = 'none';
        img.onload = function() {
          yext.sizeImage(this, 114, 114);
          $(this).fadeIn();
        };
        img.src = response.url;

        const $clone = $photoWrapper.clone();
        const $trash = $clone.find('.js-icon-trash');

        $clone.find('.js-photo-container').prepend(img);

        // NOTE(schakraborty): Filtering based on name since authenticityToken is also added
        $trash.find('input[name=image]').val(response.url);
        $currentImage.removeClass('icon-add-photo');

        $trash.click(function() {
          $trash.find('form').submit();
        });

        $currentImage.append($clone);
        $('.js-next-button').removeClass('btn-disabled');
      }
    });

    $form.on('always.field', function() {
      yext.dialog.hideDelayedProgressDialog();
    });

    $form.on('error.field', function() {
      yext.dialog.showErrorDialog(yext.msg('There was an error saving your photo.'));
    });
  };

  /**
   * Special Offer
   */
  LogCommon.prototype.bindSpecialOffer = function() {
    const $specialOffer = $('.js-specialoffer-fields');
    const $next = $('.js-next-button');

    if (!$specialOffer.length) {
      return;
    }

    const specialOffer = new yext.location.SpecialOffer($specialOffer);

    // NOTE(azhang): the saving of this field is handled by onSubmitBase

    $(specialOffer).on('updated', function() {
      $next.removeClass('btn-disabled');
    });
  };

  /**
   * Websites
   */
  LogCommon.prototype.bindWebsites = function() {
    const $field = $('.js-websites-field');
    const $form = $field.closest('form');
    const $next = $('.js-next-button');

    if (!$field.length) {
      return;
    }

    const websites = new yext.location.Websites($field);

    // NOTE(azhang): the saving of this field is handled by onSubmitBase

    $(websites).on('updated', function() {
      $next.removeClass('btn-disabled');
    });
  };

  /**
   * Business hours
   */
  LogCommon.prototype.bindHours = function() {
    const $hours = $('.js-business-hours');
    const $next = $('.js-next-button');

    if (!$hours.length) {
      return;
    }

    const dayHours = new yext.location.hours.DayHours($hours);
    const field = new yext.Field($hours);

    // Keep form from being submitted if indeterminate
    field.setValidator(function() {
      return !dayHours.indeterminate;
    });

    $hours.on('beforeSubmit.field', function() {
      if (dayHours.indeterminate) {
        markCompleted();
      }
    });

    $hours.on('save.field', function(e, response) {
      validateAndGoToNextPage(response, $hours);
    });

    $(dayHours).on('updated.hours', function() {
      $next.removeClass('btn-disabled');
    });
  };

  LogCommon.prototype.bindCategories = function() {
    const $field = $('.js-categories-field');
    const $form = $field.closest('form');
    const $next = $('.js-next-button');

    if (!$field.length) {
      return;
    }

    const categoriesField = yext.location.categories.create($field);
    const field = new yext.Field($form);

    $form.on('beforeSubmit.field', function() {
      categoriesField.setFieldData();
    });

    $form.on('save.field', function(e, response) {
      validateAndGoToNextPage(response, $form);
      if (response.stale) {
        $form.find('.js-field-timestamp').val(response.field.timestamp);
      }
    });

    $(categoriesField).on('updated', function() {
      $next.removeClass('btn-disabled');
    });
  };

  LogCommon.prototype.textFields = function() {
    const field = $('.description-edit .js-text-field');
    const isFieldPresent = !!field.length;

    const fieldId = isFieldPresent ? field.data('fieldId') : undefined;
    const usageType = isFieldPresent
      ? goog.module.get('yext.dam.assetselector.usage').forProfileFields(fieldId)
      : undefined;

    yext.textfield.create(field, fieldId, undefined, false, usageType);
  };

  /**
   * Processes a submit via ajax.
   *
   * @param form the form element
   * @param data the data, if null then the form data is used
   * @param url the url to send to
   * @param func the callback function to use on success
   */
  var onSubmitBase = function(form, data, url, func) {
    const $form = $(form);
    $form.find('input.placeholder').val('');
    $.ajax({
      type: 'POST',
      url: url,
      data: data || $form.serialize(),
      success: function(data) {
        if (typeof func === 'function') {
          func(data, $form);
        }
      },
      fail: function(data) {
        yext.dialog.showErrorDialog(yext.msg('There was an error processing your data'));
      },
    });

    return false;
  };

  /**
   * Performs validation of the data and then redirects to the next page
   */
  var validateAndGoToNextPage = function(data, $form) {
    if ($form.hasClass('js-form-with-error-class')) {
      validateErrorsWithErrorClass(data, $form);
    } else {
      validateErrors(data, $form);
    }
    validateStale(data);
    if (data && data.status == 'success') {
      goToNextPage();
    }
  };

  /**
   * Checks for errors in the data and adds error class to the input
   * Currently only used in hours but keeping the use case for the future
   */
  var validateErrorsWithErrorClass = function(data, $form) {
    if ('error' in data) {
      for (const key in data.error) {
        addErrorClassToInput($('[name="' + key + '"]'));
        $('.field-generic-error').show();
      }
    }
  };

  /**
   * Checks for errors in the data and appends it to the error container
   */
  var validateErrors = function(data, $form) {
    $('.error').remove(); // remove any existing error elements
    if ('error' in data) {
      if (typeof data.error == 'object') {
        for (const key in data.error) {
          const errorHtml = errorContainer(data.error[key]);
          $('[name="' + key + '"]', $form).parent().append(errorHtml);
        }
      } else if (typeof data.error == 'string') {
        $form.append(errorContainer(data.error)).show();
      }
    }
  };

  var addErrorClassToInput = function($input) {
    $input.addClass('validation-error');
  };

  /**
   * Verifies if the data was stale (if another change happened already).
   */
  var validateStale = function(data) {
    if (data && data.stale) {
      const message = yext.msg('Your changes could not be made because another user edited this field since you loaded this page. Please refresh and try again.');

      yext.dialog.showErrorDialog(message);
    }
  };

  /**
   * Redirects to the next page (saves progress)
   */
  var goToNextPage = function() {
    if ($('.pc-content').data('useSerialEdit')) {
      getUrlAndRedirect(window.logRoutes.serialNext);
    } else {
      getUrlAndRedirect(window.logRoutes.next);
    }
  };

  /**
   * Redirects to the next page (doesn't save progress)
   */
  var skipPage = function() {
    getUrlAndRedirect(window.logRoutes.skip);
  };

  var optOut = function() {
    getUrlAndRedirect(window.logRoutes.optOut);
  };

  var doesNotApply = function() {
    getUrlAndRedirect(window.logRoutes.doesNotApply);
  };

  var markCompleted = function() {
    getUrlAndRedirect(window.logRoutes.markCompleted);
  };

  /**
   * Gets a JSON at the given URL and redirects to the URL in the response.
   */
  var getUrlAndRedirect = function(url) {
    $.ajax({
      url: url,
      success: function(data) {
        if (data.url) {
          window.location.href = data.url;
        }
      },
    });
  };
  /**
   * Wraps the error inside an error container
   */
  var errorContainer = function(error) {
    return '<span class="error">' + error + '</span>';
  };

  const _logecl = yext.storm.Logecl;

  _logecl.init = function(options) {
    return new LogEcl(options);
  };

  /**
   * Bindings intended for the enhanced lists section only
   * @constructor
   */
  var LogEcl = function(options) {
    this.$container = $('.js-enhancedlist');
    if (options && options.container) {
      this.$container = options.container;
    }
    this.options = options;
    this.bindSkipModal();
    this.bindAssociateNext();
    this.bindUploadNext();
    this.bindSubmitForm();
    this.bindDescriptionAutoResize();
    this.bindSendFileUrlExpandToggle();
    this.bindMoreLessToggle();
    if (!(options && options.isSingleEdit)) {
      this.bindAddRemoveItemOption();
      this.bindEclInputs(true);
    }

    if (options && options.isManualAdd) {
      this.bindRemove();
    }
    this.bindYoutube();
    this.initItems();
    this.bindEnableNext();
    this.initStringlists();

    this.enhancedListItems = new yext.storm.enhancedlists.LOGItems();
    this.enhancedListItems.setupPriceOptions($('.js-enhancedlist-item'));
    this.bindSingleEclSelect($('.js-single-ecl-select'));

    // Setup the calendar for the events page
    const self = this;
    $.each($('.enhanced-list-type-Calendar'), function(index, value) {
      self.setupEclDatePair($(value));
    });
  };
  goog.exportSymbol('LogEcl', LogEcl);

  LogEcl.prototype.initStringlists = function() {
    const self = this;
    this.$container.find('.js-enhancedlist-item').each(function() {
      $(this).find('.js-stringlist-edit').each(function() {
        const $this = $(this);
        $this.data('stringlist', new yext.location.StringList({
          container: $this,
          field: $this.data('fieldName'),
          list: $this.find('.stringlist-items'),
        }));
      });
    });
  };

  LogEcl.prototype.initItems = function() {
    this.bindPhotoButtons();
  };

  /**
   * Bind the button and link in the ecl modal that asks whether the user intends
   * to mark all ecls as not applicable. The create button only works if at least
   * one element is checked, while the skip link unchecks all boxes before submitting
   */
  LogEcl.prototype.bindSkipModal = function() {
    const $skipModalForm = $('#ecl-skip-modal-form');

    $('.js-ecl-skip-modal-confirm').click(function() {
      $skipModalForm.find('input').prop('checked', false);
      $skipModalForm.submit();
    });

    $('.js-ecl-skip-modal-create').click(function() {
      if ($skipModalForm.find('input').filter(':checked').length > 0) {
        $skipModalForm.submit();
      }
    });
  };

  /**
   * Bind the Next button on the associate lists page and limit the selection to 5.
   */
  LogEcl.prototype.bindAssociateNext = function() {
    const $error = $('.ecl-select-error');
    $error.empty().hide();

    const $form = $('#enhancedListsForm');
    const checkboxes = $form.find('input[type="checkbox"]');
    checkboxes.change(function() {
      $error.empty().hide();
      const current = checkboxes.filter(':checked').length;
      checkboxes.filter(':not(:checked)').prop('disabled', current >= 5);
    });

    $(document).on('click.log', '.js-associate-lists:not(.btn-disabled)', function() {
      const current = checkboxes.filter(':checked').length;
      if (current > 0 && current <= 5) {
        if ($('.js-ecl-new-checkbox:checked').length > 0) {
          const link = $('.js-create-new-ecl').attr('href');
          window.location.href = link;
        } else {
          switch ($('.js-list-type').val()) {
            case 'ProductList':
              yext.dialog.showDelayedProgressDialog(yext.msg('Adding product lists to locations...'));
              break;
            case 'Bios':
              yext.dialog.showDelayedProgressDialog(yext.msg('Adding bios to locations...'));
              break;
            case 'Calendar':
              yext.dialog.showDelayedProgressDialog(yext.msg('Adding calendars to locations...'));
              break;
            case 'Menu':
              yext.dialog.showDelayedProgressDialog(yext.msg('Adding menus to locations...'));
              break;
          }
          // fake the delay so the user at least sees the message message
          setTimeout(function() {
            $form.submit();
          }, 2000);
        }
      } else {
        $error.text(yext.msg('Please only select up to 5 lists')).show();
      }
    });
  };

  /*
   * On Select screen with single existing ECL
   * This function highlights the selected option by adding a styling class
   */
  LogEcl.prototype.bindSingleEclSelect = function($container) {
    $container.find('.js-checkbox').change(function(e) {
      $('.js-checkbox').closest('label').removeClass('selected');
      if (this.checked) {
        $(this).closest('label').toggleClass('selected');
      }
    });
  };

  /**
   * Bind the Next button in the file upload/web url submission page and limits
   * the input to one or the other.
   */
  LogEcl.prototype.bindUploadNext = function() {
    const $linkForm = $('#js-ecl-submit-link');
    const $fileForm = $('#js-ecl-submit-file');
    const $linkInput = $linkForm.find('[name=listUrl]');
    const $fileInput = $fileForm.find('[name=listFile]');
    const $filenameDisplay = $('.ecl-upload-filename');

    const hasFileText = function() {
      return $fileInput[0].value.trim().length > 0;
    };

    const hasLinkText = function() {
      return $linkInput[0].value.trim().length > 0;
    };

    $('.js-upload-list').click(function() {
      const hasFile = hasFileText();
      const hasLink = hasLinkText();

      if (hasFile && hasLink) {
        // Shouldn't happen since we disable one field or the other, but just in case...
        yext.dialog.showErrorDialog(yext.msg('Please choose to only send one file or one link'));
      } else if (hasFile) {
        $fileForm[0].submit();
      } else if (hasLink) {
        $linkForm[0].submit();
      }
    });

    const toggleNext = function(shouldEnable) {
      if (shouldEnable) {
        yext.storm.logflownav.enableNextInLogFlow();
      } else {
        yext.storm.logflownav.disableNextInLogFlow();
      }
    };

    $linkInput.inputchange(function() {
      const hasLink = hasLinkText();
      if ($fileInput.prop('disabled') != hasLink) {
        $fileInput.prop('disabled', hasLink);
        $linkInput.siblings('.ecl-import-instructions').toggle();
        toggleNext(hasLink);
      }
    });

    $fileInput.change(function() {
      const hasFile = hasFileText();
      updateFilename(hasFile);
      if ($linkInput.prop('disabled') != hasFile) {
        $linkInput.prop('disabled', hasFile);
        $fileInput.siblings('.ecl-import-instructions').toggle();
        toggleNext(hasFile);
      }
    });

    var updateFilename = function(hasFile) {
      if (hasFile) {
        let filename = $fileInput[0].value.trim();
        const startIndex = filename.indexOf('\\') >= 0 ? filename.lastIndexOf('\\') : filename.lastIndexOf('/');
        filename = filename.substring(startIndex);
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
          filename = filename.substring(1);
        }
        $filenameDisplay.text(filename);
      } else {
        $filenameDisplay.text(yext.msg('No file chosen'));
      }
    };

    $('.ecl-upload-btn').click(function() {
      $fileInput.click();
    });
  };

  /**
   * Converts dates and times to american format
   *
   * @param {!jQuery} $form The form containing ecl inputs for events
   * @return {!Array} List of form element name/value pairs
   * @suppress {deprecated}
   */
  const i18nSerializeEventParams = function($form) {
    const formValues = $form.serializeArray();
    for (let i = 0; i < formValues.length; i++) {
      const name = formValues[i].name;
      const $input = $form.find('input[name="' + name + '"]');
      if (name.indexOf('itemEventTimeStartDay') !== -1
        || name.indexOf('itemEventTimeEndDay') !== -1) {
        formValues[i].value = yext.time.formatDate($input.datepicker('getDate'));
      } else if (name.indexOf('itemEventTimeStartTime') !== -1
        || name.indexOf('itemEventTimeEndTime') !== -1) {
        formValues[i].value = $input.data().timepickerLegacyValue;
      }
    }
    return formValues;
  };

  /**
   * Process the ECL Forms to get the data
   * @return {!Object} process form data for submit
   */
  LogEcl.prototype.getFormData = function() {
    let formData = [];
    const self = this;

    this.$container.find('form.enhancedlists:not(.gallery):not(.string-list)').each(function() {
      const $this = $(this);
      let formValues = [];
      if ($this.hasClass('event-time')) {
        formValues = i18nSerializeEventParams($this);
      } else {
        formValues = $(this).serializeArray();
      }
      formData = formData.concat(formValues);
    });

    // get the Form data of stringlists
    $('.js-enhancedlist-item .js-stringlist-edit').each(function() {
      const stringList = $(this).data('stringlist');
      const stringListFormData = stringList.serializeForm();

      // It's necessary to do this replace because serializeForm does a
      // find on the name, which gets tripped up by special characters, but it also
      // uses the same field argument to return results, so we now need to remove
      // escapes afterward. Also, we prefer to have items[3].value instead of
      // item3.value for use with play, so we change that as well in the results.
      $.each(stringListFormData, function() {
        this.name = this.name.replace(/\\/g, '')
          .replace('.item', '.items[')
          .replace('.onAllLocs', '].onAllLocs')
          .replace('.value', '].value');
      });
      formData = formData.concat(stringListFormData);
    });
    const data = {};
    $.each(formData, function() {
      if (!data[this.name]) {
        data[this.name] = [];
      }
      data[this.name].push(this.value);
    });

    const $listIdContainer = $('.js-enhanced-list-id');
    if ($listIdContainer.length > 0) {
      data['listId'] = $listIdContainer.val();
    }

    if (this.options['locationIds']) {
      data['locationIds'] = this.options['locationIds'];
    }

    this.$container.find('.js-enhancedlists-form-item').each(function() {
      const $input = $(this).find('.js-ecl-imagejson');
      if (data[$input.attr('name')] && $input.val()) {
        data[$input.attr('name')].push($input.val());
      } else if ($input.val()) {
        data[$input.attr('name')] = [$input.val()];
      }
    });

    return data;
  };

  /**
   * Binding the 'Next' button to the submit
   */
  LogEcl.prototype.bindSubmitForm = function() {
    const self = this;

    $(document).on('click.log', '.create-list-next', function(e) {
      e.preventDefault();

      if ($(this).hasClass('btn-disabled')) {
        LogCommon.prototype.alertIncompleteTask();
        return;
      }

      // delete the extra ecl items
      self.removeEmptyEnhancedList(true);
      self.submitForm(self.onSubmitSuccess);
    });
  };

  /**
   * Response to when ajax to submit ECL is successful
   * @return {[type]} [description]
   */
  LogEcl.prototype.onSubmitSuccess = function(data) {
    const $createItemSave = $('.create-list-next');
    $createItemSave.removeClass('disabled');
    if (data.success != null) {
      if (data.success) {
        goToNextPage();
      } else {
        yext.notify.showError(yext.msg('Something went wrong. Please try again later.'));
      }
    } else if (data.error) {
      for (const field in data.error) {
        // These fields have slashes in them which require special handling
        if (field.indexOf('biosEducation') != -1
          || field.indexOf('biosCertifications') != -1
          || field.indexOf('biosServices') != -1) {
          var $field = $('[name$=".value"]', '[id="' + field + 'List"]');
        } else {
          var $field = $('[name="' + field + '"]');
        }

        // Where to put the error messages
        const $errorText = $('.item-field-error', $field.closest('form'));

        for (var i in data.error[field]) {
          const fieldDetails = data.error[field][i];
          const value = fieldDetails.value + '<br>';
          var order = fieldDetails.order;

          // Ensure error messages on options isn't shown multiple times
          if ($errorText.html().indexOf(value) == -1) {
            $errorText.append(value);
          }

          // Highlight field
          if (typeof order == 'undefined') {
            $field.addClass('validation-error');
          } else {
            var i = 0;
            $field.each(function() {
              // Some fields, like menu options, have the same name. Highlight based on order.
              if (order == i++) {
                $(this).addClass('validation-error');
              }
            });
          }
        }
        $errorText.show();
      }
    }
  };

  /**
   * Runs ajax to submit a new ECL Form
   */
  LogEcl.prototype.submitForm = function(onSuccess) {
    const self = this;
    self.checkForEnhancedListContent();
    const $createItemSave = $('.create-list-next');

    if ($createItemSave.hasClass('disabled')) {
      return;
    } else {
      $createItemSave.addClass('disabled');
    }

    // Clear old errors
    self.$container.find('.error').hide();
    self.$container.find('.item-field-error').text('');
    self.$container.find('.validation-error').removeClass('validation-error');

    const data = self.getFormData();

    $.ajax({
      type: 'POST',
      url: self.options.createOrUpdateUrl,
      data: data,
      success: onSuccess,
    });
  };

  /**
   * Setup automatic resizing of the description text area
   */
  LogEcl.prototype.bindDescriptionAutoResize = function() {
    this.$container.find('[name$=\'itemDescription\']').keydown(function(event) {
      const ele=event.target;
      const t=ele.scrollTop;
      ele.scrollTop=0;
      if (t > 0) {
        ele.style.height=(ele.offsetHeight+t+t)+'px';
      }
    });
  };

  /**
   * Toggle expand collapse of the file/url menu
   */
  LogEcl.prototype.bindSendFileUrlExpandToggle = function() {
    const self = this;
    this.$container.find('.js-enhancedlist-expand-toggle').click(function(e) {
      self.$container.find('.js-enhancedlist-expand-container').toggle();
      self.$container.find('.js-enhancedlist-expand-toggle .enhanced-list-send-menu-option-icon').toggleClass('closed');
    });
  };

  /**
   * More/Less button toggle
   */
  LogEcl.prototype.bindMoreLessToggle = function() {
    const self = this;
    this.$container.on('click', '.js-more-toggle', function(e) {
      e.preventDefault();
      const $this = $(this);
      $this.parents('.js-enhancedlist-item').find('.js-enhanced-list-more-container').toggle();
      if ($this.hasClass('open')) {
        // TRANSLATORS: Link to expand the content
        $this.removeClass('open').find('.content').html(yext.msg('More'));
        $this.find('.less-arrow').removeClass('less-arrow').addClass('more-arrow');
      } else {
        // TRANSLATORS: Link to display less content
        $this.addClass('open').find('.content').html(yext.msg('Less'));
        $this.find('.more-arrow').removeClass('more-arrow').addClass('less-arrow');
        self.enhancedListItems.intializeStringList($(this).closest('.js-enhancedlist-item'));
      }
    });
  };

  /**
   * binds the remove action to the buttons
   */
  LogEcl.prototype.bindRemove = function() {
    const self = this;

    this.$container.on('click', '.js-remove-item', function() {
      $(this).closest('.js-enhancedlist-item').remove();
      // if this is the list item in the list, don't show it
      const count = self.$container.find('.js-enhancedlist-item').length;
      if (count == 1) {
        self.$container.find('.js-remove-item').hide();
      }
    });
  };

  /**
   * Sets up the item option add and removal handling
   */
  LogEcl.prototype.bindAddRemoveItemOption = function() {
    const self = this;

    const addOption = function(optionList) {
      const $optionLi = optionList.find('.template').clone(false).show();
      $optionLi.removeClass('template');

      optionList.append($optionLi);

      updateOptions($optionLi.parent());
    };

    // Updates the options if needed based on the number of fields displayed
    var updateOptions = function($optionUl) {
      const $optionLi = $optionUl.find('li:not(.template)');
      const $optionContainer = $optionLi.closest('.price-options-field');
      $optionLi.find('.reorder-icon, .remove-item').toggle($optionLi.length != 1);
    };

    // Add single empty option by default if item has no options.
    $.each(self.$container.find('.option-list'), function() {
      if ($(this).find('li:not(.template)').length == 0) {
        addOption($(this));
      }
    });

    // handle add item click
    this.$container.on('click', '.add-item-option', function() {
      addOption($(this).parent().siblings('ul.option-list'));
    });

    // Remove option clicked handling
    this.$container.on('click', '.option-list .remove', function() {
      const $optionLi = $(this).closest('li');
      const $optionUl = $optionLi.parent();
      $optionLi.remove();
      updateOptions($optionUl);
    });
  };

  /**
   * Sets up YouTube video handling
   */
  LogEcl.prototype.bindYoutube = function() {
    $('.js-youtube-modal').on('submit', '.js-youtube-submit', function() {
      return onYouTubeSubmit($(this), logRoutes.addEclVideo, $(this).parent().parent());
    });

    // Unfortunately, we need multiple modals because the form element exists
    // within each modal, and in order to pinpoint a specific one, we rely on
    // the itemIndex, which we obtain here by parsing it out of the id of the
    // thumbnail image element.
    $('.js-enhancedlist').on('click', '.js-add-youtube-video', function() {
      // gets the item index from the img id, which is of form: youtubeThumb{index}
      const itemIndex = $(this).find('img').first().attr('id').substring(12);

      $('#youtube-modal' + itemIndex).dialog({
        width: 400,
        height: 200,
        modal: true,
      });
    });

    $('.js-youtube-wrapper').on('click', '.js-delete-youtube-video', function(e) {
      e.stopPropagation();
      const $img = $(this).siblings('img').first();

      // same trick to get item index from youtubeThumb{index}
      const itemIndex = $img.attr('id').substring(12);

      const $youtubeModal = $('#youtube-modal' + itemIndex);
      const $youtubeForm = $youtubeModal.find('form').first();
      const $urlInput = $youtubeForm.children('input[name$=\'videoUrl\']').first();

      deleteYouTube($youtubeForm, $urlInput, $youtubeModal);
      $(this).parent().hide();
    });
  };

  /**
   * Bind removed of enhancedlist item
   * @param  {function()} onRemove function callback when item is removed
   */
  LogEcl.prototype.bindRemoveItem = function(onRemove) {
    this.$container.on('click', '.js-remove-item', function() {
      const $this = $(this);

      $this.closest('.js-enhancedlist-item').remove();
      if (yext.isFunction(onRemove)) {
        onRemove($this);
      }
    });
  };

  /**
   * Runs ajax to get a new EnhancedListItem and appends it to the DOM
   */
  LogEcl.prototype.addNewEnhancedListItem = function(onAdd) {
    const itemNum = this.$container.find('.js-enhancedlist-item').not('.js-enhancedlist-form-template').length;
    const listType = this.$container.find('.js-enhancedlist-type').val();
    const self = this;

    $.ajax({
      type: 'GET',
      url: window.logRoutes.addEclItem,
      data: {itemIndex: itemNum, listType: listType, businessId: yext.businessId},
      success: function(data) {
        self.$container.find('.js-enhancedlist-item-last').removeClass('js-enhancedlist-item-last');
        const $data = $(data).addClass('js-enhancedlist-item-new-empty').addClass('js-enhancedlist-item-last');
        self.$container.append($data);
        $data.fadeIn();
        self.enhancedListItems.setupPriceOptions($data);
        LogCommon.prototype.bindCharCount();
        LogCommon.prototype.bindPlaceholder();
        self.setupEclDatePair($data);
        self.initItems();
        self.initStringlists();
        $data.find('.tooltip-icon').contextualHelp();
        // run on Add Callback
        if (yext.isFunction(onAdd)) {
          onAdd();
        }
      },
      error: function(error) {
        $('.js-enhancedlist-view-error').html(yext.msg('An error has occurred. Please refresh and try again.')).slideDown();
      },
    });
  };

  LogEcl.prototype.getEclItemCount = function() {
    return this.$container.find('.js-enhancedlist-item').length;
  };

  /**
   * Sets up adding New ECL content
   */
  LogEcl.prototype.bindEclInputs = function(shouldAddNew) {
    const that = this;
    const emptyClass = 'js-enhancedlist-item-new-empty';

    this.$container.on('change paste keyup', '.js-el-user-input', function() {
      const $container = $(this).closest('.js-enhancedlist-item');
      if ($(this).val() && $container.hasClass(emptyClass)) {
        $container.removeClass(emptyClass);
        if (that.$container.find('.js-enhancedlist-item-new-empty').length < 1) {
          if (shouldAddNew) {
            that.addNewEnhancedListItem();
          }
        }
      } else {
        // check if this value is empty
        if (!$(this).val()) {
          const isEmpty = checkForEmptyInputs($container);
          if (isEmpty && !$container.hasClass(emptyClass)) {
            $container.addClass(emptyClass);
            that.removeEmptyEnhancedList();
          }
        }
      }
    });

    function checkForEmptyInputs($container) {
      let isEmpty = true;
      $container.find('.js-el-user-input').each(function() {
        const $input = $(this);
        const value = $input.val();
        if (value!=false) {
          // there is a empty imput that isn't empty, break from the loop (that's all we need)
          // and set isEmpty so it doesn't get deleted
          isEmpty = false;
          return false;
        }
      });
      return isEmpty;
    }
  };

  LogEcl.prototype.checkForEnhancedListContent = function() {
    if (this.$container.find('.js-enhancedlist-item').not('.js-enhancedlist-item-new-empty').length < 1) {
      this.$container.find('.js-option-opt-out-reminder').show();
      this.$container.find('.js-opt-out').addClass('highlight-option');
    } else {
      this.removeEmptyEnhancedList();
    }
  };

  /*
   * remove the empty-new-item that isn't the last one
   */
  LogEcl.prototype.removeEmptyEnhancedList = function(isSubmit) {
    if (!isSubmit && this.$container.find('.js-enhancedlist-item').length > 3) {
      this.$container.find('.js-enhancedlist-item-new-empty').not('.js-enhancedlist-item-last').remove();
    } else if (isSubmit && this.$container.find('.js-enhancedlist-item').length > 1) {
      this.$container.find('.js-enhancedlist-item-new-empty').remove();
    }
  };

  /**
   * For a given image, place it on the photo list item with the specified imageUrl.
   * Also set metafata on the list item to the image data via the input.
   * @param {!jQuery} $img the image tag we will be giving a url
   * @param {!jQuery} $photoLi the photo list item we will be setting all the data for
   * @param String imageUrl the url representing the image
   * @param Number imageWidth the width of the image
   * @param Number imageHeight the height of the image
   */
  LogEcl.prototype.showUploadedPhoto = function($img, $photoLi, imageUrl, imageWidth, imageHeight) {
    $img.attr('src', imageUrl);
    $img.show();
    $photoLi.find('.js-delete-photos').removeAttr('style');
    const encodedInfo = {
      url: imageUrl,
      height: imageHeight,
      width: imageWidth,
    };
    $photoLi.find('input').attr('value', window.JSON.stringify(encodedInfo));
  };

  /**
   * When a photo thumbnail is clicked, show the asset selector
   * @param {!jQuery} $photoLi The container in which the user clicked and the image is housed
   */
  LogEcl.prototype.addPhotoClicked = function($photoLi) {
    const self = this;

    yext.dam.assetselector.show({
      'type': yext.dam.assetselector.types.PHOTO,
      'includeUsedAssets': false,
      'hideEnterImageUrl': false,
    },
    'gallery-photo',
    false);

    $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
      const photo = new yext.photoupload.Photo({
        asset: asset,
      });
      const data = {
        photo: photo,
      };
      if (asset.file && !asset.croppedImage) {
        data.file = asset.file;
        data.fileInput = asset.fileInput;
      }
      self.onPhotoAdd(e, $photoLi, data);
    });
  };

  /**
   * Triggered when the user selects a photo from the asset selector. Immediate upload the file to the server and display the image.
   * @param {event} e
   * @param {!jQuery Object} $photoLi The container in which the user clicked and the image is housed
   * @param {!Object} photoData The data needed for the photo including the photo object, and files
   */
  LogEcl.prototype.onPhotoAdd = function(e, $photoLi, photoData) {
    const self = this;

    const $img = $photoLi.find('img');

    const onSuccess = function(imageUrl, width, height) {
      $photoLi.addClass('has-photo');
      self.showUploadedPhoto($img, $photoLi, imageUrl, width, height);
    };

    const onFailure = function() {
      yext.notify.showError(yext.msg('Something went wrong please try again.'));
    };

    if (photoData.file) {
      photoData.photo.setFileIndex(0);
      yext.fileupload.upload({
        files: [photoData.file],
        fileInputs: [photoData.fileInput],
        action: yext.storm.routesDEPRECATED.Photos.uploadObject(),
        data: [{'name': 'photo', 'value': yext.JSON.stringify(photoData.photo)}],
        done: function(data) {
          onSuccess(data.imageUrl, data.width, data.height);
        },
        error: onFailure,
      });
    } else {
      $.ajax({
        type: 'POST',
        url: yext.storm.routesDEPRECATED.Photos.uploadObject(),
        data: [{'name': 'photo', 'value': yext.JSON.stringify(photoData.photo)}],
        success: function(data) {
          onSuccess(data.imageUrl, data.width, data.height);
        },
        error: onFailure,
      });
    }
  };

  /**
   * Sets up the photo handling
   */
  LogEcl.prototype.bindPhotoButtons = function() {
    // Uploads the photo to the server and adds a thumbnail for it on the page.
    // TODO: We are uploading immediately when the file is selected, but may want
    // to change it to upload when the 'upload' button is pressed similar to add photos
    const self = this;
    self.$container.find('.js-add-photos').click(function() {
      self.addPhotoClicked($(this));
    });

    // photo modal event handling
    self.$container.find('.js-photoUpload').click(function() {
      $('#photoUploadButton').click();
    });

    self.$container.find('#photoUploadButton').change(function() {
      $('.js-upload-btn').removeClass('btn-disabled');
      $('.js-upload-file').html($(this).val());
    });

    // delete photo event handling
    self.$container.find('.js-delete-photos').click(function(e) {
      e.stopPropagation();

      const li = $(this).closest('li');

      li.find('img').hide();
      li.find('.icon-trash').hide();
      li.find('input').attr('value', '');
      li.removeClass('has-photo');
    });
  };

  LogEcl.prototype.bindEnableNext = function() {
    this.$container.find('input').change(function() {
      const name = $(this).attr('name');

      // skip handling of the upload page since that's done elsewhere.
      if (name != 'listUrl' && name != 'listFile') {
        yext.storm.logflownav.enableNextInLogFlow();
      }
    });
  };

  LogEcl.prototype.setupEclDatePair = function($container) {
    const $startDay = $container.find('input[name$=".itemEventTimeStartDay"]');
    const $endDay = $container.find('input[name$=".itemEventTimeEndDay"]');
    const $startTime = $container.find('input[name$=".itemEventTimeStartTime"]');
    const $endTime = $container.find('input[name$=".itemEventTimeEndTime"]');
    const $endContainer = $container.find('.item-event-time-end');
    this.enhancedListItems.setupDatepair($startDay, $endDay, $startTime, $endTime, $endContainer);
  };

  /**
   * Handles a youtube link submit via ajax.
   *
   * @param form the form to submit
   * @param url the link to call
   * @param element the element to modify the html of on success
   */
  var onYouTubeSubmit = function(form, url, element) {
    const func = function(data) {
      validateErrors(data);
      validateStale(data);

      const url = element.find('input[name="location.youtube_videos.url"]').val();
      if (url) {
        showYoutubePreview(url, true);
        yext.storm.logflownav.enableNextInLogFlow();
      }
      if (data.timestamp) {
        element.find('input[name="location.youtube_videos.timestamp"]').val(data.timestamp);
      }
    };

    return onSubmitBase(form, null, url, func);
  };

  /**
   * Processes a removal of a youtube video, mainly by clearing html elements
   *
   * @param formElement the youtube form
   * @param inputElement the url input
   * @param modalElement the modal
   */
  var deleteYouTube = function(formElement, inputElement, modalElement) {
    inputElement.val('');
    modalElement.dialog('close');
    formElement.submit();
  };

  /**
   * For use in the addphotosandvideos page
   * @constructor
   */
  const LogPhotosVideos = function() {
    this.bindYoutube();
    this.utilities = new LogUtilities();
  };
  goog.exportSymbol('LogPhotosVideos', LogPhotosVideos);

  /**
   * Sets up YouTube link handling.
   */
  LogPhotosVideos.prototype.bindYoutube = function() {
    const self = this;
    const url = $.trim($('#youtube-modal input[name="location.youtube_videos.url"]').val());
    const $youtubeWrapper = $('.js-add-youtube-video-wrap');

    yext.videochooser.init('video.value', yext.storm.logflownav.enableNextInLogFlow());

    if (url) {
      showYoutubePreview(url, false);
    }

    $('.js-add-youtube-video-wrap').on('click', '.js-add-youtube-video', function() {
      const fieldId = 'location.youtube_videos';
      yext.dam.assetselector.show({
        type: yext.dam.assetselector.types.VIDEO,
        includeUsedAssets: false,
        usageType: goog.module.get('yext.dam.assetselector.usage').forProfileFields(fieldId),
      },
      fieldId);

      $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
        self.utilities.updateVideoPreview(asset.videoinfo);
        $('#youtubeForm').find('input[name="location.youtube_videos.url"]').val(asset.videoinfo.url);
        onYouTubeSubmit($('#youtubeForm'), logRoutes.updateField, $('#youtubeForm'));
      });
    });

    /**
     * Calls cleanup of the youtube video form when the delete button is clicked
     */
    const onDeleteClicked = function(e, $trashbin) {
      e.stopPropagation();
      const formElement = $('#youtubeForm');
      deleteYouTube(formElement, $('[name="location.youtube_videos\\.url"]', formElement), $('#youtube-modal'));
      $youtubeWrapper.find('.js-add-youtube-video').removeAttr('style').removeClass('is-thumbnail');
      $youtubeWrapper.find('.youtube-preview').empty();
      $youtubeWrapper.find('.js-delete-youtube-video').hide();
      if ($('.add-photo-display').find('img').length == 0) {
        $('.log-next').addClass('btn-disabled');
      }
    };

    $youtubeWrapper.on('click', '.js-delete-youtube-video', function(e) {
      onDeleteClicked(e, $(this));
    });
  };

  /**
   * Show youtube preview renders the preview on page load and on ajax call back.
   *
   * @param {string} url Youtube url to render the preview
   * @param {boolean} a boolean indicates edit/add
   */
  var showYoutubePreview = function(url, edit) {
    const ytid = url.replace(/^.*v=/, '');
    yext.youtube.getVideosDetails(
      [ytid],
      function(videos) {
        if (videos && videos.length) {
          const video = videos[0];
          const template = $('.video-display-template').html();
          const html = yext.utils.youtube.fixupVideoTemplate(template, video);
          // update thumbnail
          $('#youtubeThumb').css('background-image', 'url(\'' + video.thumbnail + '\')');
          // update video
          $('.youtube-preview').html(html);

          if (edit) {
            $('#youtube-modal')
              .dialog('destroy');
          }
        } else {
          $('#youtubeForm').append(yext.msg(
            '<span class="error">The URL you entered is not a valid YouTube video URL.</span>'));
        }
      });
  };

  /**
   * For use in the build listing pages
   * @constructor
   */
  const LogBuildListing = function() {
    this.currentField = $('.js-field-submit').find('input[name=field]').val();
    // For descriptions and featured messages, only enable Next if value is non-empty
    this.nextEnabledOnTouch = ['description'];
    this.fadeInIntroBubble();
    this.bindEnableNext();
    this.bindAssetAddActions();
  };
  goog.exportSymbol('LogBuildListing', LogBuildListing);

  LogBuildListing.prototype.fadeInIntroBubble = function() {
    $('.intro-bubble').delay(1000).fadeIn(700);
  };

  LogBuildListing.prototype.bindEnableNext = function() {
    const self = this;
    $('form input,textarea').inputchange(function() {
      const name = $(this).attr('name');
      let shouldEnable = false;
      const $changedIndicator = $('.js-changed-input');

      if (name == 'description.value') {
        const hasChanged = $changedIndicator && $changedIndicator.last().val();
        shouldEnable = hasChanged || $(this).val();
      } else {
        shouldEnable = true;
      }

      self.toggleLogFlowNext(shouldEnable);
    });

    $(yext.textfield.events)
      .on('removeasset.textfield', function(e, asset) {
        const $changedIndicator = $('.js-changed-input');

        if ($.inArray(self.currentField, self.nextEnabledOnTouch) >= 0) {
          const hasChanged = $changedIndicator && $changedIndicator.last().val();
          self.toggleLogFlowNext(hasChanged);
          self.bindAssetAddActions();
        }
      });
  };

  LogBuildListing.prototype.bindAssetAddActions = function() {
    const self = this;
    $(yext.dam.assetselector.events)
      .on('added.assetselector', function(e, asset) {
        if ($.inArray(self.currentField, self.nextEnabledOnTouch) >= 0) {
          self.toggleLogFlowNext(true);
        }
      });
  };

  LogBuildListing.prototype.toggleLogFlowNext = function(shouldEnable) {
    if (shouldEnable) {
      yext.storm.logflownav.enableNextInLogFlow();
    } else {
      yext.storm.logflownav.disableNextInLogFlow();
    }
  };
})();
